import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop - Automatically scrolls the window and all main scrollable
 * containers back to top (0, 0) whenever the route pathname changes.
 *
 * The sidebar nav is also `overflow-y-auto`, but it persists across routes:
 * resetting it would jump the menu back to the top every time someone picks
 * an item further down the list, so anything inside `.cx-sidebar` is skipped.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);

    // Also reset any scrollable layout containers if present in the DOM
    const scrollContainers = document.querySelectorAll(
      '.main-content, .custom-scrollbar, [class*="overflow-y-auto"]'
    );
    scrollContainers.forEach((container) => {
      if (container.closest('.cx-sidebar')) return;
      if (container.scrollTop > 0) {
        container.scrollTop = 0;
      }
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
